// extracted by mini-css-extract-plugin
module.exports = {"favorite_button":"_7a3fb80146--favorite_button--h25dU"};